<template>
  <div></div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "Logout",
  props: {},
  methods: {
    ...mapMutations(["LOGOUT"])
  },
  created() {
    this.LOGOUT();
    this.$router.push("/login");
  }
};
</script>
<style lang="scss"></style>
